import React from 'react';
import { useTemperatureUnit } from '../contexts/TemperatureUnitContext';
import { Button } from "@/components/ui/button";

const TemperatureUnitToggle = () => {
  const { unit, toggleUnit } = useTemperatureUnit();

  const handleToggle = () => {
    toggleUnit();
  };

  return (
    <Button
      variant="ghost"
      onClick={handleToggle}
      className="text-sm text-gray-600 dark:text-gray-400 hover:bg-transparent p-0"
    >
      °C/°F
    </Button>
  );
};

export default TemperatureUnitToggle;